// extracted by mini-css-extract-plugin
export default {"search":"Search__search___2pQv_"};